var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckedMark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "check-24px",
  width: 17.715,
  height: 17.715,
  viewBox: "0 0 17.715 17.715",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}.cls-2{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  d: "M0 0h17.715v17.715H0z",
  className: "cls-1",
  "data-name": "Path 88"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_89",
  d: "M7.536 13.4l-3.078-3.079-1.048 1.041 4.126 4.126 8.857-8.857-1.04-1.041z",
  className: "cls-2",
  "data-name": "Path 89",
  transform: "translate(-.893 -1.464)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckedMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/checked_mark.4a66c206a3c1af7f87f33ba67e448521.svg";